import * as styles from "./styles.css";
import * as M from "@discovery/prelude/lib/data/maybe";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _IsUserPremiumFromPartners } from "@discovery/common-dplus/lib/state";
import { Typography, Tags, HeaderVariants } from "../../atoms/typography";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { useHistory } from "@discovery/common-dplus/lib/hooks";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
import { navigateTo } from "../../../utils/common";
import { useUser } from "../../../utils/hooks/useUser";
import { setAuthRedirectUrl } from "../../../utils/authUrl";
export const HamburgerList = ({ titleM, route, loginUrl, anonymous, imageSrc, alias, onClickHamburgerList, collectionAttributes, }) => {
    const { isPremiumUser } = useUser();
    const [isPremiumUserFromPartner] = useGlobalState(_IsUserPremiumFromPartners);
    const isUserPremium = isPremiumUserFromPartner || isPremiumUser;
    const collectionAttributeHints = collectionAttributes === null || collectionAttributes === void 0 ? void 0 : collectionAttributes.hints;
    const hintToHide = collectionAttributeHints && M.fromMaybe(collectionAttributeHints, []);
    const hideReedemVoucherForPartners = hintToHide && hintToHide.includes("hide-for-subscribers") && isUserPremium;
    const redeemVoucherUrl = loginUrl + "/redeem";
    const leaderboardUrl = loginUrl + config.authenticationURLs.contestWinners;
    const [, history] = useHistory();
    const redirectTo = (path) => {
        const likeWatchUrl = loginUrl + "/login?flow=OTPLogin&header=likeOrWatch";
        const authRedirect = setAuthRedirectUrl(path);
        const redirectUrl = path === "/redeem-voucher" ? loginUrl + "/redeem" : authRedirect;
        switch (alias) {
            case "lhs-watch-later-secondary":
            case "lhs-favorites-secondary":
            case "lhs-liked-videos-secondary":
            case "lhs-redeem-voucher":
                navigateTo(`${likeWatchUrl}&returnUrl=${redirectUrl}`);
                break;
            case "lhs-subscribe-and-win":
                navigateTo(path);
                break;
            case "lhs-contest-past-winners":
            case "lhs-blf-winner":
                navigateTo(leaderboardUrl);
                break;
            default:
                navigateTo(path);
        }
    };
    const onItemClick = (path) => {
        onClickHamburgerList && onClickHamburgerList();
        switch (alias) {
            case "lhs-redeem-voucher":
                navigateTo(redeemVoucherUrl);
                break;
            case "lhs-contest-past-winners": // TODO: Some case is in TEST env
            case "lhs-blf-winner":
                navigateTo(leaderboardUrl);
                break;
            default:
                history.push(path);
        }
    };
    return anonymous ? (React.createElement("div", { className: styles.contentWrapper, onClick: () => redirectTo(route), id: "#hamburgerList" }, !hideReedemVoucherForPartners && (React.createElement(React.Fragment, null,
        React.createElement("img", { src: imageSrc, className: styles.likeHover }),
        React.createElement(RenderMaybe, null, M.map((title) => (React.createElement(Typography, { classNameM: M.of(styles.contentListLabel), variant: HeaderVariants.headingSix, tag: Tags.h6 },
            React.createElement(React.Fragment, null, title))), titleM)))))) : (React.createElement("div", { className: styles.contentWrapper, id: "#hamburgerList", onClick: () => onItemClick(route) }, !hideReedemVoucherForPartners && (React.createElement(React.Fragment, null,
        React.createElement("img", { src: imageSrc, className: styles.likeHover }),
        React.createElement(RenderMaybe, null, M.map((title) => (React.createElement(Typography, { classNameM: M.of(styles.contentListLabel), variant: HeaderVariants.headingSix, tag: Tags.h6 },
            React.createElement(React.Fragment, null, title))), titleM))))));
};

